import { HTMLAttributes } from 'react';
import { cn } from '@bridebook/aura';

export const SummarySection = ({ children, className }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col gap-2 p-4 xl:gap-4', className)}>{children}</div>
);

export const SummarySectionTitle = ({ children }: { children: React.ReactNode }) => (
  <div className="text-base leading-[120%] font-semibold text-space">{children}</div>
);

export const SummarySectionRegularText = ({ children }: { children?: React.ReactNode }) => (
  <div className="text-base leading-[150%] tracking-[-0.02em] break-all whitespace-pre-line text-space">
    {children}
  </div>
);
